import { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";
import TagliandiPage from "../pages/tagliandi/page";
import ImpiantoFrenantePage from "../pages/impianto-frenante/page";
import ManutenzionePage from "../pages/manutenzione/page";
import DiagnosiPage from "../pages/diagnosi/page";
import ZoneServite from "../pages/zone-servite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/tagliandi",
    element: <TagliandiPage />,
  },
  {
    path: "/impianto-frenante",
    element: <ImpiantoFrenantePage />,
  },
  {
    path: "/manutenzione",
    element: <ManutenzionePage />,
  },
  {
    path: "/diagnosi",
    element: <DiagnosiPage />,
  },
  {
    path: "/zone-servite",
    element: <ZoneServite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
